import { render, staticRenderFns } from "./widgetSecThreatName.vue?vue&type=template&id=18d9ea0b&scoped=true&"
import script from "./widgetSecThreatName.vue?vue&type=script&lang=js&"
export * from "./widgetSecThreatName.vue?vue&type=script&lang=js&"
import style0 from "./widgetSecThreatName.vue?vue&type=style&index=0&id=18d9ea0b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d9ea0b",
  null
  
)

export default component.exports